(() => {
  const define = (name, component) => { if (!customElements.get(name)) customElements.define(name, component); };
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  define('pf-delivery-area', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const field = this.querySelector('input');
        const value = field.value.trim();
        const province = Number(value.slice(0, 2));
        const valid = /^\d{5}$/.test(value) && province >= 1 && province <= 52 && Number(value.slice(2)) > 0;
        field.setAttribute('aria-invalid', String(!valid));
        setText(this.querySelector('[data-area-result]'), !valid ? this.dataset.invalid : [7,35,38,51,52].includes(province) ? this.dataset.excluded : this.dataset.valid);
      });
    }
  });
  define('pf-gift-finder', class extends HTMLElement {
    static select(products, budget, style, delivery) {
      const eligible = products.filter(item => style === 'any' || item.style === style);
      const available = item => item.variants.filter(v => v.available === true && !v.requiresPlan && Number.isInteger(v.price) && v.price > 0 && typeof v.image === 'string' && v.image.length > 0 && item.variants.filter(other => other.image === v.image).length === 1);
      const prices = eligible.flatMap(item => available(item).map(v => v.price + delivery));
      const candidates = eligible.flatMap(item => {
        const variants = available(item).filter(v => v.price + delivery <= budget).sort((a,b) => b.price - a.price);
        return variants.length ? [{...item, variant:variants[0], total:variants[0].price + delivery}] : [];
      }).sort((a,b) => b.total - a.total || String(a.id).localeCompare(String(b.id)));
      let choices = candidates;
      if (style === 'any') {
        const seen = new Set();
        const diverse = candidates.filter(item => {if (seen.has(item.style)) return false;seen.add(item.style);return true;});
        const ids = new Set(diverse.slice(0,3).map(item => item.id));
        choices = [...diverse.slice(0,3), ...candidates.filter(item => !ids.has(item.id))];
      }
      return {choices:choices.slice(0,3).sort((a,b) => a.total - b.total), minimum:prices.length ? Math.min(...prices) : null};
    }
    static variantURL(path, id, currentURL) {
      const url = new URL(path, currentURL);
      url.searchParams.set('variant', String(id));
      const preview = new URL(currentURL).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.pathname + url.search;
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-finder-result]');
      this.heading = this.querySelector('[data-finder-heading]');
      this.cards = this.querySelector('[data-finder-cards]');
      this.minimum = this.querySelector('[data-finder-minimum]');
      this.other = this.querySelector('[data-finder-other]');
      try {
        this.copy = JSON.parse(this.querySelector('[data-finder-copy]').textContent);
        this.products = JSON.parse(this.querySelector('[data-finder-products]').textContent);
        if (!Array.isArray(this.products) || this.products.some(item => !item.id || !item.url || !Array.isArray(item.variants))) throw new Error('Invalid catalogue');
        this.delivery = Number(this.dataset.delivery);
        if (this.dataset.currency !== 'EUR' || !Number.isInteger(this.delivery) || this.delivery < 0) {
          setText(this.status, this.copy.currency);return;
        }
        this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:'EUR'});
        this.form.hidden = false;
        setText(this.status, this.updateAvailability() || this.copy.ready);
        this.form.addEventListener('submit', event => {event.preventDefault();this.render();});
        this.form.addEventListener('change', () => this.clear(this.updateAvailability() || this.copy.changed));
        this.form.addEventListener('reset', () => setTimeout(() => {
          this.clear(this.updateAvailability() || this.copy.ready);this.form.querySelector('[name=budget][value="80"]').focus();
        }, 0));
        this.other.addEventListener('click', () => {this.form.elements.style.value = 'any';this.render();this.form.querySelector('[name=style]:checked').focus();});
      } catch (_) {this.fail();}
    }
    updateAvailability() {
      const budget = Number(this.form.elements.budget.value) * 100;
      let message = '';
      for (const input of this.form.querySelectorAll('[name=style]')) {
        const result = this.constructor.select(this.products, budget, input.value, this.delivery);
        input.disabled = result.choices.length === 0;
        const label = input.closest('label');
        const hint = label.querySelector('[data-style-availability]');
        if (hint) {
          hint.hidden = !input.disabled;
          setText(hint, input.disabled ? (result.minimum === null ? this.copy.style_unavailable : this.copy.style_from.replace('[price]', this.money.format(result.minimum / 100))) : '');
        }
        if (input.checked && input.disabled && input.value !== 'any') {
          message = this.copy.style_reset.replace('[style]', label.querySelector('.pf-style-label').textContent.trim());
          this.form.querySelector('[name=style][value="any"]').checked = true;
        }
      }
      this.form.querySelector('[type=submit]').disabled = !this.constructor.select(this.products, budget, this.form.elements.style.value, this.delivery).choices.length;
      return message;
    }
    clear(message) {
      this.cards.replaceChildren();this.cards.hidden = true;
      this.heading.hidden = true;setText(this.heading, '');
      this.minimum.textContent = '';this.minimum.hidden = true;this.other.hidden = true;
      setText(this.status, message);
    }
    fail() {this.clear(this.dataset.error);this.form.hidden = true;}
    render() {
      const changed = this.updateAvailability();
      if (changed) {this.clear(changed);return;}
      if (!this.form.reportValidity()) return;
      try {
        const euros = Number(this.form.elements.budget.value);
        if (![40,60,80,120].includes(euros)) throw new Error('Invalid budget');
        const budget = euros * 100;
        const style = this.form.elements.style.value;
        const result = this.constructor.select(this.products, budget, style, this.delivery);
        this.clear(result.choices.length ? '' : result.minimum === null ? this.copy.none : this.copy.empty);
        if (!result.choices.length) {
          if (result.minimum !== null) {
            this.minimum.textContent = this.copy.minimum.replace('[price]', this.money.format(result.minimum/100));this.minimum.hidden = false;
          }
          this.other.hidden = style === 'any' || !this.constructor.select(this.products, budget, 'any', this.delivery).choices.length;
        }
        for (const item of result.choices) {
          const card = this.querySelector('[data-finder-card]').content.cloneNode(true);
          const put = (selector, value) => setText(card.querySelector(selector), value);
          put('[data-title]', item.title);put('[data-option]', item.variant.title);
          card.querySelector('[data-option]').hidden = !item.variant.title;
          put('[data-reason]', item.reason);put('[data-price]', this.money.format(item.variant.price/100));
          put('[data-shipping]', this.money.format(this.delivery/100));put('[data-total]', this.money.format(item.total/100));
          const link = card.querySelector('[data-link]');
          link.href = this.constructor.variantURL(item.url, item.variant.id, location.href);
          link.setAttribute('aria-label', link.textContent + ': ' + item.title + (item.variant.title ? ', ' + item.variant.title : ''));
          const img = card.querySelector('[data-image]');
          const image = item.variant.image;
          if (!image) throw new Error('Missing size photo');
          img.src = image;
          img.alt = item.title + (item.variant.title ? ', ' + item.variant.title : '');
          this.cards.append(card);
        }
        this.cards.hidden = !result.choices.length;
        if (result.choices.length) {
          setText(this.heading, (result.choices.length === 1 ? this.copy.found_one : this.copy.found).replace('[count]', result.choices.length));
          this.heading.hidden = false;
          requestAnimationFrame(() => {
            if (this.heading.hidden) return;
            this.heading.focus({preventScroll:true});
            const headerHeight = document.querySelector('sticky-header')?.getBoundingClientRect().height || 0;
            const top = this.heading.getBoundingClientRect().top + window.scrollY - headerHeight - 24;
            window.scrollTo({top:Math.max(0, top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          });
        }
        this.dispatchEvent(new CustomEvent('pf:gift_finder', {bubbles:true,detail:{style,matched:Boolean(result.choices.length),count:result.choices.length}}));
      } catch (_) {this.fail();}
    }
  });
  define('pf-occasion-reminder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('[name=date]');
      const hint = this.querySelector('[data-reminder-schedule]');
      const iso = value => [value.getFullYear(),String(value.getMonth()+1).padStart(2,'0'),String(value.getDate()).padStart(2,'0')].join('-');
      const schedule = () => {
        const now = new Date();
        const tomorrow = new Date(now.getFullYear(),now.getMonth(),now.getDate()+1);
        input.min = iso(tomorrow);
        const date = input.value;
        const chosen = /^\d{4}-\d{2}-\d{2}$/.test(date) ? new Date(date+'T00:00:00') : null;
        if (!chosen || !Number.isFinite(chosen.getTime()) || iso(chosen) !== date || date < input.min) return null;
        // Calendar arithmetic keeps the alarm in the future across daylight-saving changes.
        for (const [days,trigger,key] of [[7,'-P7D','week'],[1,'-P1D','day'],[0,'PT0S','sameDay']]) {
          const alarm = new Date(chosen.getFullYear(),chosen.getMonth(),chosen.getDate()-days);
          if (alarm > now) return {trigger,text:this.dataset[key]};
        }
        return null;
      };
      const update = () => {
        const next = schedule();
        setText(hint,next ? next.text : this.dataset.schedule);
        setText(this.querySelector('[data-reminder-result]'),'');
      };
      input.addEventListener('input',update);
      input.addEventListener('focus',update);
      update();
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const values = new FormData(event.currentTarget);
        const name = String(values.get('occasion')).trim();
        const date = String(values.get('date'));
        const status = this.querySelector('[data-reminder-result]');
        const next = schedule();
        if (!name || !next) {setText(status,this.dataset.error);return;}
        setText(hint,next.text);
        const escape = value => value.replace(/\\/g,'\\\\').replace(/\r?\n/g,'\\n').replace(/;/g,'\\;').replace(/,/g,'\\,');
        const stamp = new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d+Z$/,'Z');
        const day = date.replace(/-/g,'');
        const lines = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Persa//Occasion reminder//EN','CALSCALE:GREGORIAN','BEGIN:VEVENT','UID:'+crypto.randomUUID()+'@persaflores.com','DTSTAMP:'+stamp,'DTSTART;VALUE=DATE:'+day,'DURATION:P1D','RRULE:FREQ=YEARLY','SUMMARY:'+escape(name),'DESCRIPTION:'+escape(this.dataset.description),'BEGIN:VALARM','ACTION:DISPLAY','TRIGGER:'+next.trigger,'DESCRIPTION:'+escape(this.dataset.before),'END:VALARM','END:VEVENT','END:VCALENDAR'];
        const folded = lines.map(line => {
          let result = '', length = 0;
          for (const char of line) {const bytes = new TextEncoder().encode(char).length;if(length+bytes>73){result+='\r\n ';length=1;}result+=char;length+=bytes;}
          return result;
        }).join('\r\n')+'\r\n';
        const url = URL.createObjectURL(new Blob([folded],{type:'text/calendar;charset=utf-8'}));
        const link = document.createElement('a');link.href=url;link.download='persa-occasion.ics';link.click();
        setTimeout(()=>URL.revokeObjectURL(url),30000);
        setText(status,this.dataset.success);
      });
    }
  });
  define('pf-usp-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.scope = this.closest('product-info');
      if (!this.scope) return;
      this.variants = JSON.parse(this.querySelector('[data-usp-variants]').textContent);
      this.kind = new URLSearchParams(location.search).get('pf_gift');
      this.package = this.querySelector('[data-usp-package]');
      if (this.package && ['memory','complete'].includes(this.kind)) {
        this.copy = JSON.parse(this.querySelector('[data-usp-package-copy]').textContent);
        this.package.hidden = false;
        setText(this.querySelector('[data-usp-package-title]'),this.copy[this.kind]);
        this.applyButton = this.querySelector('[data-usp-apply]');
        this.fallback = this.querySelector('[data-usp-package-status]').textContent;
        this.applyButton.addEventListener('click', async () => {
          const layout = this.scope.querySelector('pf-guided-layout');
          const keys = this.kind === 'complete' ? ['vase-roma','photo'] : ['photo'];
          if (!layout?.mounted || !keys.every(key=>layout.row(key) && !layout.row(key).hidden)) return;
          if (this.applying) return;
          this.applying = true;this.applyButton.disabled = true;
          let complete = true;
          for (const key of keys) {
            const row = layout.row(key);
            if (row.dataset.selected !== 'true') row.querySelector('[data-gift-toggle]').click();
            let selected = false;
            for (let attempt = 0; attempt < 50; attempt++) {
              if (!this.isConnected) return;
              if (!layout.base.giftBusy && row.dataset.selected === 'true') {selected = true;break;}
              await new Promise(resolve => setTimeout(resolve,50));
            }
            if (!selected) {complete = false;break;}
          }
          this.applying = false;this.schedule();
          if (!complete) {setText(this.querySelector('[data-usp-package-status]'),this.fallback);return;}
          layout.open('extras',this.applyButton);
          setText(this.querySelector('[data-usp-package-status]'),this.copy.applied);
          this.dispatchEvent(new CustomEvent('pf:gift_offer_selected',{bubbles:true,detail:{offer:this.kind}}));
        });
      }
      this.schedule = () => {if (!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=null;this.sync();});};
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.scope,{childList:true,subtree:true,attributes:true,attributeFilter:['value','aria-pressed','data-selected','disabled']});
      this.scope.addEventListener('change',this.schedule);
      this.scope.addEventListener('input',this.schedule);
      this.schedule();
    }
    sync() {
      const layout = this.scope.querySelector('pf-guided-layout');
      const field = layout?.form?.querySelector('[name=id]') || this.scope.querySelector('form[action*="/cart/add"] [name=id]');
      const variant = this.variants.find(item=>String(item.id)===field?.value);
      if (variant) setText(this.querySelector('[data-usp-selected]'),this.dataset.selectedCopy.replace('[size]',variant.title));
      if (this.applyButton) {
        const keys = this.kind === 'complete' ? ['vase-roma','photo'] : ['photo'];
        const disabled = Boolean(this.applying) || !layout?.mounted || !keys.every(key=>{const row=layout.row(key);return row && !row.hidden && !row.querySelector('[data-gift-toggle]')?.disabled;});
        if(this.applyButton.disabled!==disabled)this.applyButton.disabled=disabled;
      }
    }
    disconnectedCallback() {this.observer?.disconnect();this.scope?.removeEventListener('change',this.schedule);this.scope?.removeEventListener('input',this.schedule);if(this.frame)cancelAnimationFrame(this.frame);this.ready=false;}
  });
})();
